import * as React from 'react'
import { HashRouter as Router, Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom'
import { IVerificationBeforeSend } from './lib/interfaces';
import { SurveyFilesContainer } from './SurveyFilesContainer';
import { SurveyProcessContainer } from './SurveyProcessContainer';
import { SurveyVerificationContainer } from './SurveyVerificationContainer';
import { SurveyVariableCoachingRulesContainer } from './SurveyVariableCoachingRulesContainer';
import { SurveyVariableFieldRulesContainer } from './SurveyVariableFieldRulesContainer';

interface ISurveyManagementContainerState {
  verification?: IVerificationBeforeSend;
}

export class SurveyManagementContainer extends React.Component<{}, ISurveyManagementContainerState> {
  state: ISurveyManagementContainerState = {}

  render() {
    return (
      <Router>
        <Switch>
          <Route path="/clients" render={(props: RouteComponentProps<any>) =>
            <SurveyFilesContainer {...props} />
          } />
          <Route path="/process/:clientAbbr" exact render={(props: RouteComponentProps<any>) =>
            <SurveyProcessContainer {...props} onSuccess={(verification) => this.setState({ verification })} />
          } />
          <Route path="/verify" exact render={(props: RouteComponentProps<any>) =>
            <SurveyVerificationContainer {...props} verification={this.state.verification} />
          } />
          <Route path="/coachingvars" exact render={(props: RouteComponentProps<any>) =>
            <SurveyVariableCoachingRulesContainer {...props} />
          } />
          <Route path="/fieldvars" exact render={(props: RouteComponentProps<any>) =>
            <SurveyVariableFieldRulesContainer {...props} />
          } />
          <Redirect to="/clients" />
        </Switch>
      </Router>
    )
  }
}
